export const APP_TITLES = {
  appName: 'دام‌یار',
  appSubtitle: 'سامانه جامع مدیریت دامداری',
  denseMode: 'نمایش فشرده',
  activeOnly: 'فقط دام‌های فعال',
  allCows: 'همه دام‌ها',
  quickSearch: 'جست‌وجوی سریع دام',
  site: 'سایت',
  unit: 'واحد',
  baharband: 'باهاربند',
};

export const STATUS_LABELS = {
  active: 'فعال',
  calf: 'گوساله',
  heifer: 'تلیسه',
  ready_service: 'آماده تلقیح',
  in_protocol: 'در برنامه درمانی',
  under_treatment: 'تحت درمان',
  inseminated: 'تلقیح‌شده',
  pregnant: 'آبستن',
  ready_dryoff: 'آماده خشکی',
  dry: 'خشک',
  dry_pregnant: 'خشک آبستن',
  fresh: 'تازه‌زا',
  sold: 'فروخته‌شده',
  dead: 'تلف‌شده',
};

export const LIFECYCLE_LABELS = {
  calf: 'گوساله',
  heifer: 'تلیسه',
  cow: 'گاو',
  dry: 'خشک',
  dry_pregnant: 'خشک آبستن',
  unknown: 'نامشخص',
};

export const MANAGEMENT_FLAG_LABELS = {
  OK_TO_BREED: 'مجاز برای تلقیح',
  DO_NOT_BREED: 'ممنوع از تلقیح',
  REPEAT_BREEDER: 'تکرارتلقیحی',
  RECHECK: 'نیازمند بازبینی',
  SYNC_ENROLLED: 'در برنامه همزمان‌سازی',
  FRESH_ATTENTION: 'پایش تازه‌زا',
  HIGH_SCC: 'سلول بدنی بالا',
  LAMENESS_RISK: 'خطر لنگش',
  WITHDRAWAL_MILK: 'شیر دارای منع مصرف',
  CULL_CANDIDATE: 'نامزد حذف',
  CULL_HOLD: 'توقف حذف',
  HOSPITAL: 'بستری',
  SPECIAL_MONITOR: 'پایش ویژه',
};

export const MANAGEMENT_FLAG_SHORT_LABELS = {
  OK_TO_BREED: 'مجاز برای تلقیح',
  DO_NOT_BREED: 'ممنوع تلقیح',
  REPEAT_BREEDER: 'تکرارتلقیحی',
  RECHECK: 'بازبینی',
  SYNC_ENROLLED: 'همزمان‌سازی',
  FRESH_ATTENTION: 'تازه‌زا',
  HIGH_SCC: 'SCC بالا',
  LAMENESS_RISK: 'لنگش',
  WITHDRAWAL_MILK: 'منع مصرف شیر',
  CULL_CANDIDATE: 'نامزد حذف',
  CULL_HOLD: 'توقف حذف',
  HOSPITAL: 'بستری',
  SPECIAL_MONITOR: 'پایش ویژه',
};

export const TIMELINE_CATEGORY_LABELS = {
  service: 'تلقیح',
  pregcheck: 'آبستنی‌سنجی',
  calving: 'زایش',
  dryoff: 'خشکی',
  abortion: 'سقط/جذب جنین',
  estrus: 'فحلی',
  treatment: 'درمان',
  medication: 'دارو',
  milk: 'شیر',
  lameness: 'لنگش',
  exit: 'خروج از گله',
  transfer: 'جابه‌جایی',
  calf: 'گوساله',
  management: 'مدیریتی',
  system: 'سیستمی',
};

export const GRID_LABELS = {
  columns: 'ستون‌ها',
  export: 'خروجی CSV',
  bulkActions: 'اقدامات گروهی',
  clearFilters: 'پاک‌کردن پالایش‌ها',
  loading: 'در حال بارگذاری...',
  noData: 'داده‌ای پیدا نشد',
  search: 'جست‌وجو',
  totalRows: 'نتایج کل',
  visibleRows: 'سطرهای این نما',
  activeSort: 'مرتب‌سازی فعال',
  activeFilters: 'پالایش‌های فعال',
  denseMode: 'نمایش فشرده',
  normalMode: 'نمایش معمولی',
};

export const COW_GRID_COLUMNS = {
  earTag: 'شماره گوش',
  smallEarTag: 'گوش کوچک',
  veterinaryNumber: 'شماره دامپزشکی',
  chkno: 'CHKNO',
  rno: 'RNO',
  name: 'نام',
  mother: 'شماره مادر',
  sire: 'شماره پدر',
  maternalGrandsire: 'پدربزرگ مادری',
  maternalGranddam: 'مادربزرگ مادری',
  maternalGranddamSire: 'پدر مادربزرگ مادری',
  maternalGranddamDam: 'مادر مادربزرگ مادری',
  site: 'سایت',
  unit: 'واحد',
  baharband: 'باهاربند',
  birthDate: 'تاریخ تولد',
  birthWeight: 'وزن تولد',
  status: 'وضعیت',
  lifecycle: 'مرحله زندگی',
  bcs: 'BCS',
  milk: 'آخرین رکورد شیر',
  flags: 'نشانگرها',
  health: 'سلامت',
  profile: 'کارت دام',
  actions: 'عملیات',
};

export function getStatusLabel(status, fallback = '-') {
  if (!status) return fallback;
  return STATUS_LABELS[status] || fallback || status;
}

export function getLifecycleLabel(lifecycle, fallback = '-') {
  if (!lifecycle) return fallback;
  return LIFECYCLE_LABELS[lifecycle] || fallback || lifecycle;
}

export function getManagementFlagLabel(code, short = false) {
  if (!code) return '-';
  return (short ? MANAGEMENT_FLAG_SHORT_LABELS : MANAGEMENT_FLAG_LABELS)[code] || code;
}

export function formatManagementFlags(flags, { short = true, limit = 3 } = {}) {
  if (!Array.isArray(flags) || flags.length === 0) return [];
  return flags
    .map((flag) => {
      if (typeof flag === 'string') return { code: flag, label: getManagementFlagLabel(flag, short) };
      return {
        code: flag?.code || flag?.flag_code || flag?.name || String(flag),
        label: getManagementFlagLabel(flag?.code || flag?.flag_code || flag?.name || String(flag), short),
      };
    })
    .filter((flag) => flag.code)
    .slice(0, limit);
}


export const REPRO_BUCKET_LABELS = {
  ready_to_breed: 'آماده تلقیح',
  pd_due: 'موعد آبستنی‌سنجی',
  recheck_due: 'موعد بازبینی',
  dryoff_due: 'موعد خشکی',
  calving_due: 'نزدیک زایش',
  repeat_breeders: 'تکرارتلقیحی‌ها',
  heifer_breed_ready: 'تلیسه‌های آماده تلقیح',
  max_service_review: 'نیازمند بررسی سقف تلقیح',
  dnb_review: 'نیازمند بررسی منع تلقیح',
};

export const BREEDING_BLOCK_REASON_LABELS = {
  dnb_active: 'به دلیل منع تلقیح، فعلاً از چرخه باروری خارج است.',
  max_services_reached: 'تعداد تلقیح‌ها به سقف سیاست باروری رسیده و باید تصمیم مدیریتی گرفته شود.',
};

export const ECONOMIC_DECISION_LABELS = {
  keep: 'نگه‌داری',
  monitor: 'پایش',
  cull_review: 'بررسی حذف',
};

export function getReproBucketLabel(code, fallback = '-') {
  if (!code) return fallback;
  return REPRO_BUCKET_LABELS[code] || fallback || code;
}

export function getBreedingBlockReasonLabel(code, fallback = '-') {
  if (!code) return fallback;
  return BREEDING_BLOCK_REASON_LABELS[code] || fallback || code;
}

export function getEconomicDecisionLabel(code, fallback = '-') {
  if (!code) return fallback;
  return ECONOMIC_DECISION_LABELS[code] || fallback || code;
}


export const SAVED_LIST_LABELS = {
  templatesTitle: 'الگوهای فهرست',
  savedListsTitle: 'فهرست‌های ذخیره‌شده',
  builderTitle: 'سازنده فهرست',
  runDefinition: 'اجرای تعریف',
  saveList: 'ذخیره فهرست',
  saveFromTemplate: 'ذخیره از روی الگو',
  exportBackend: 'خروجی CSV رسمی',
  loadTemplate: 'اجرای الگو',
  loadSavedList: 'اجرای فهرست',
  matchAll: 'همه شرط‌ها',
  matchAny: 'هرکدام از شرط‌ها',
  addFilter: 'افزودن شرط',
  removeFilter: 'حذف شرط',
  fields: 'فیلدها',
  operator: 'عملگر',
  value: 'مقدار',
  previewResults: 'پیش‌نمایش نتایج',
  activeDefinition: 'تعریف فعال',
  noSelection: 'هنوز هیچ الگو یا فهرستی انتخاب نشده است.',
  noTemplates: 'هنوز الگویی برای نمایش وجود ندارد.',
  noSavedLists: 'هنوز فهرست ذخیره‌شده‌ای ثبت نشده است.',
  searchPlaceholder: 'جست‌وجو در الگوها و فهرست‌ها...',
  columnsSection: 'ستون‌های خروجی',
  resultsCount: 'تعداد نتیجه',
  templateTag: 'برچسب',
  personalList: 'فهرست شخصی',
  sharedList: 'اشتراکی',
  systemList: 'سیستمی',
  definitionSaved: 'فهرست با موفقیت ذخیره شد.',
  templateSaved: 'فهرست از روی الگو ذخیره شد.',
};

export const LIST_FIELD_LABELS = {
  cow_id: 'شناسه دام',
  ear_tag: 'شماره گوش',
  name: 'نام',
  site_id: 'شناسه سایت',
  site_code: 'کد سایت',
  site_name: 'سایت',
  unit_id: 'شناسه واحد',
  unit_code: 'کد واحد',
  unit_name: 'واحد',
  status: 'وضعیت',
  status_display: 'وضعیت',
  lifecycle_stage: 'مرحله زندگی',
  baharband_id: 'شناسه باهاربند',
  baharband_code: 'کد باهاربند',
  baharband_name: 'باهاربند',
  dim: 'روزهای شیردهی',
  days_open: 'روزهای باز',
  days_pregnant: 'روزهای آبستنی',
  days_since_service: 'روزهای پس از تلقیح',
  last_heat_date: 'آخرین فحلی',
  last_service_date: 'آخرین تلقیح',
  last_calving_date: 'آخرین زایش',
  last_dryoff_date: 'آخرین خشکی',
  next_pd_due_date: 'موعد تست آبستنی',
  expected_dryoff_date: 'موعد خشکی',
  expected_calving_date: 'موعد زایش',
  heat_return_window_start: 'شروع پنجره بازگشت فحلی',
  heat_return_window_end: 'پایان پنجره بازگشت فحلی',
  under_treatment: 'تحت درمان',
  withdrawal_active: 'منع مصرف شیر',
  active_protocol_count: 'تعداد پروتکل فعال',
  active_medication_count: 'تعداد داروی فعال',
  latest_milk_kg: 'آخرین شیر',
  avg_last_2_milk_kg: 'میانگین ۲ رکورد آخر شیر',
  avg_last_3_milk_kg: 'میانگین ۳ رکورد آخر شیر',
  avg_last_5_milk_kg: 'میانگین ۵ رکورد آخر شیر',
  latest_scc: 'آخرین SCC',
  has_recent_lameness: 'لنگش اخیر',
  latest_lameness_score: 'امتیاز لنگش',
  management_flags: 'نشانگرها',
  economic_risk_band: 'ریسک اقتصادی',
  economic_decision: 'تصمیم اقتصادی',
  economic_total_score: 'امتیاز اقتصادی',
  estimated_sale_value: 'ارزش تقریبی فروش',
  operational_status: 'وضعیت عملیاتی',
  current_baharband: 'باهاربند فعلی',
  dnb_flag: 'منع تلقیح',
  ok_to_breed_flag: 'مجاز برای تلقیح',
  repeat_breeder_flag: 'تکرارتلقیحی',
  fresh_risk_flag: 'پایش تازه‌زا',
  cull_candidate_flag: 'نامزد حذف',
};

export const LIST_OPERATOR_LABELS = {
  eq: 'برابر با',
  ne: 'نابرابر با',
  in: 'یکی از این مقادیر',
  not_in: 'به‌جز این مقادیر',
  gte: 'بزرگ‌تر یا مساوی',
  lte: 'کوچک‌تر یا مساوی',
  gt: 'بزرگ‌تر از',
  lt: 'کوچک‌تر از',
  isnull: 'خالی / بدون مقدار',
  lte_today: 'تا امروز',
  gte_today: 'از امروز به بعد',
  contains_flag: 'دارای این نشانگر',
  contains_any_flags: 'دارای یکی از نشانگرها',
  contains_all_flags: 'دارای همه نشانگرها',
  icontains: 'شامل',
  search: 'جست‌وجو در متن',
};

export const ECONOMIC_RISK_LABELS = {
  low: 'کم',
  medium: 'متوسط',
  high: 'زیاد',
  critical: 'بحرانی',
};

export function getListFieldLabel(code, fallback = '-') {
  if (!code) return fallback;
  return LIST_FIELD_LABELS[code] || fallback || code;
}

export function getListOperatorLabel(code, fallback = '-') {
  if (!code) return fallback;
  return LIST_OPERATOR_LABELS[code] || fallback || code;
}

export function getEconomicRiskLabel(code, fallback = '-') {
  if (!code) return fallback;
  return ECONOMIC_RISK_LABELS[code] || fallback || code;
}
